import { css } from "@emotion/react";

export const useStyles = () => ({
    whiteContentTopRadius: css({
        backgroundColor: "#ffffff",
        marginTop: "-10px !important",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
        overflow: "hidden",
    }),
    listOrderItemsDiv: css({
        overflow: "auto",
    }),
    listOrderItemsContainer: css({
        backgroundColor: "#f3f6f6",
    }),
    listOrderItemsButton: css({
        backgroundColor: "white",
        borderBottom: "1px solid #d2d4d6",
        marginBottom: "3px",
        padding: "15px",
        textTransform: "capitalize",
        borderRadius: 0,
        width: "100%",
    }),
    listOrderItemsButtonTitle: css({
        fontSize: "10px",
        color: "#abadb1",
        textAlign: "left",
    }),
    listOrderItemsButtonLeftContent: css({
        fontSize: "12px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "left",
    }),
    listOrderItemsButtonRightContent: css({
        fontSize: "12px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "right",
    }),
    greyContentBar: css({
        backgroundColor: "#f3f6f6",
        height: "35px",
        borderBottom: "1px solid #f5f5f5",
        padding: "10px",
    }),
    greyLeftContent: css({
        "& p": {
            fontSize: "12px",
            color: "#abadb1",
            marginTop: 0,
            textAlign: "left",
            textTransform: "capitalize",
        },
    }),
    greyCenterContent: css({
        "& p": {
            fontSize: "12px",
            marginTop: 0,
            color: "#abadb1",
            textAlign: "center",
            textTransform: "capitalize",
        },
    }),
    greyRightContent: css({
        "& p": {
            fontSize: "12px",
            marginTop: 0,
            color: "#abadb1",
            textAlign: "right",
            textTransform: "capitalize",
        },
    }),
    whiteContentBarContainer: css({
        backgroundColor: "#ffffff",
    }),
});
